// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CTA_RETURN_BACK = "Vra\u0165 se zp\u011bt";
